module.exports = __webpack_public_path__ + "img/5390399.c8260e29.png";